export const priceComponent = {
  key: 'priceComponent',
  name: 'Price - Component',
  siteIdentifier: 'global',

  savingsLabel: '{percentageDiscount}% savings',
};
